import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import invertersActions from '@state/inverters/actions';
import useVariables from '@common/hooks/useVariables';

function useCondicionesAlarma({ form }) {

  const dispatch = useDispatch();
  const { getAlarmsFields } = useVariables();

  const conditions = useSelector(({ inverters: a }) => a.createEditValues.conditions);
  const isEditDefault = useSelector(({ inverters }) => inverters.isEditDefault);

  const [geofences, setGeofences] = useState({ next: null, results: null });
  // const [conditions, setConditions] = useState(form.getFieldValue('conditions') || []);

  const addNewGroupConditions = useCallback(() => {

    dispatch(invertersActions.addCreateEditValuesGroupConditions());
    // eslint-disable-next-line
  }, []);

  const removeGroupCondition = useCallback((index) => {

    dispatch(invertersActions.removeCreateEditValuesGroupConditions(index));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    if (conditions.length === 0) addNewGroupConditions();
    getAlarmsFields();
    // eslint-disable-next-line
  }, []);

  return {
    conditions,
    addNewGroupConditions,
    removeGroupCondition,
    geofences,
    setGeofences,
    isEditDefault,
  };

}

export default useCondicionesAlarma;
